import { CashAdvanceRelease } from "./CashAdvanceRelease";

export enum CashAdvanceQuoteTypeEnum {
  High = 0,
  Balanced = 1,
  Low = 2,
}

export interface CashAdvanceSummary {
  id?: string;
  currency?: string;
  trancheFactor?: number;
  totalAmount: number;
  amount: number;
  totalAmountUsd?: number;
  artistPercentageUntilDischarge?: number; // e.g. 0.7
  strmPercentageUntilDischarge?: number; // e.g. 0.3
  artistPercentageAfterDischarge?: number;
  strmPercentageAfterDischarge?: number;
  minimumNumberOfReleasesRequired?: number;
  validUntil?: string; // ISO date
  selectedReleases?: CashAdvanceRelease[];
  label?: string;
  type?: CashAdvanceQuoteTypeEnum;
}
